import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import InCartItem from '../InCartItem';
import {uniqBy} from 'lodash';
import Loading from '../../images/loading.gif';

import baseplateBlue from '../../images/baseplates/blue.jpg';
import baseplateGrey from '../../images/baseplates/grey.jpg';
import baseplateBlack from '../../images/baseplates/black.jpg';
import baseplateBeige from '../../images/baseplates/beige.jpg';

import cordBlack from '../../images/cords/black.png';
import cordNeonPink from '../../images/cords/neon-pink.png';
import cordRedYellow from '../../images/cords/red-yellow.png';
// import cordWhite from '../../images/cords/white.png';
import cordRudi from '../../images/cords/rudi.png';
import cordGreyBlack from '../../images/cords/grey-black.png';
import cordTurquoise from '../../images/cords/turquoise.png';
import cordPurpleBlack from '../../images/cords/purple-black.png';
import cordOrange from '../../images/cords/orange.png';
import cordOle from '../../images/cords/ole.png';
import cordBrunhilde from '../../images/cords/brunhilde.png';
import cordSissi from '../../images/cords/sissi.png';
import cordFranz from '../../images/cords/franz.png';
import cordLorelei from '../../images/cords/lorelei.png';
import cordAlfons from '../../images/cords/alfons.png';
import cordMathilde from '../../images/cords/mathilde.png';
import cordHerbert from '../../images/cords/herbert.png';
import cordSibylle from '../../images/cords/sibylle.png';
import cordPaulina from '../../images/cords/paulina.png';
import cordDorothea from '../../images/cords/dorothea.png';
import cordFritz from '../../images/cords/fritz.png';
import cordEster from '../../images/cords/ester.png';
import cordHans from '../../images/cords/hans.png';
import cordJosef from '../../images/cords/josef.png';
import warning from '../../images/warning.svg';

const dataBaseplateNames = {
  "6x3": '42 x 58 cm / 16.5 x 22.8"',
  "6x2": '42  x 40 cm / 16.5 x 15.7"',
  "2x4": '16  x 76 cm / 6.3 x 29.8"',
  "2x2": '16  x 40 cm / 6.3 x 15.7"',
  "10x3": '72  x 58 cm / 28.3 x 22.8"',
  "10x2_KOMPANJA": '68  x 40 cm / 26.8 x 15.7" (Kompanja)',
  "8x2": '55  x 40 cm / 21.7 x 15.7"',
  "6x1": '55  x 22 cm / 27.7 x 8.7"',
  "12x1": '81  x 22 cm / 31.9 x 8.7"',
  "4x2": '29  x 40 cm / 11.4 x 15.7"',
  "4x3": '29  x 59 cm / 11.4 x 22.8"',
  "4x4": '29 x 76 cm / 11.4 x 29.9"'
}



class Sidebar extends React.Component {

  _countInArray(array, what) {
    var count = 0;
    for (var i = 0; i < array.length; i++) {
        if (array[i].variantId === what) {
            count++;
        }
    }
    return count;
  }


  _addZeroes(num) {
    // Cast as number
    var num = Number(num);
    // If not a number, return 0
    if (isNaN(num)) {
        return 0;
    }
    // If there is no decimal, or the decimal is less than 2 digits, toFixed
    if (String(num).split(".").length < 2 || String(num).split(".")[1].length<=2 ){
        num = num.toFixed(2);
    }
    // Return the number
    return num;
}

  _renderAddedProducts = (products) => {
    // Unique Products stands for an array of products
    // where the repeating products are

    const uniqueProducts = uniqBy(products, 'variantId')
    return uniqueProducts.map((product, id) => {
      console.log(product)
      return (
        <ReactCSSTransitionGroup
          transitionName="example"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
          transitionAppear={true}
          transitionAppearTimeout={500}
          key={id}
          >
          <InCartItem variantId={product.variantId} variantTitle={product.variantTitle} quantity={this._countInArray(products, product.variantId)} title={product.title} imgSrc={product.imgSrc} price={(product.price * this._countInArray(products, product.variantId)).toFixed(2)} type={product.type}/>
        </ReactCSSTransitionGroup>
      )
    })
  }

  render() {
    const { stringData, activeLanguage } = this.props;
    console.log('al', activeLanguage);
    const { activeInitialBaseplate, products, showBaseplateSelectionControls, isWallBaseplate } = this.props;
    // console.log(products);
    const baseplatePrice = 
    activeInitialBaseplate === '10x3' ? 92.00 : 
    (activeInitialBaseplate === '10x2_KOMPANJA' && showBaseplateSelectionControls) ? 56.00 : 
    (activeInitialBaseplate === '10x2_KOMPANJA' && !showBaseplateSelectionControls) ? 0 : 
    activeInitialBaseplate === '4x4' ? 46.00 :
    activeInitialBaseplate === '4x3' ? 36.80 :
    activeInitialBaseplate === '4x2' ? 33.00 :
    activeInitialBaseplate === '12x1' ? 41.40 :
    activeInitialBaseplate === '8x1' ? 33.00 :
    activeInitialBaseplate === '8x2' ? 48.30 :
    activeInitialBaseplate === '10x3' ? 92.00 :
    activeInitialBaseplate === '2x2' ? 33.00 :
    activeInitialBaseplate === '2x4' ? 46.00 :
    activeInitialBaseplate === '6x2' ? 39.00 :
    activeInitialBaseplate === '6x3' ? 52.00 :
    52.23
    const cordPrice = activeInitialBaseplate === '10x3' ? 9.99 : (activeInitialBaseplate === '10x2_KOMPANJA' || isWallBaseplate)? 0 : 6.99
    const urlParams = new URLSearchParams(window.location.search);
    const haube = JSON.parse(JSON.stringify(urlParams.get('haube')));
    let ctaLink = 'https://vantale.de/pages/vantale%C2%AE-wohnmobil-wand-organizer-selbst-gestalten-schritt-3';
    
    if (activeInitialBaseplate === '6x3') {
      ctaLink = 'https://vantale.de/pages/vantale%C2%AE-wohnmobil-organizer-selbst-gestalten-schritt-3';

      if (haube) {
        ctaLink = 'https://vantale.de/pages/vantale%C2%AE-wohnmobil-captain-chair-organizer-selbst-gestalten-schritt-3'
      }
    }

    else if (activeInitialBaseplate === '10x3') {
      ctaLink = 'https://vantale.de/pages/vantale%C2%AE-wohnmobil-doppelbank-organizer-selbst-gestalten-schritt-3';
    }

    return(
      <div className="sidebar">
        <div className="inside-header">
         <div className="price-container">
          <h2 className="price">
            <span>Shopping List</span>
            {/* <span>{(this.props.cartTotalPrice + baseplatePrice + cordPrice).toFixed(2)}€</span> */}
           </h2>
            {/* <ul>
              <li>
                Preis Modified Module
              </li>
              <li>
                62,99€
              </li>
            </ul> */}
         </div>
        </div>

        <div className="inner">
          <div className="in-cart-items-wrapper">
            <div className="attention">
              <div>
                <img src={warning} alt="warning" />
              </div>
              <div>
                <p>{this.props.stringData.string_53}</p>
              </div>
            </div>
            {showBaseplateSelectionControls &&
              <>
                {/* <h3 className="price">Shopping List</h3> */}
                <InCartItem 
                  variantTitle={ this.props.activeBaseplate === 0 ? 'Blue' : this.props.activeBaseplate === 1 ? 'Black' : this.props.activeBaseplate === 2 ? 'Grey' : 'Beige'}
                  quantity={1} 
                  title={`Baseplate (${dataBaseplateNames[this.props.activeInitialBaseplate]})`} 
                  imgSrc={ this.props.activeBaseplate === 0 ? baseplateBlue : this.props.activeBaseplate === 1 ? baseplateBlack : this.props.activeBaseplate === 2 ? baseplateGrey : baseplateBeige} 
                  price={this._addZeroes(baseplatePrice)} 
                  type={'baseplate'}
                />

                {(activeInitialBaseplate === '6x3' || activeInitialBaseplate === '10x3') &&
                  <InCartItem 
                    variantTitle={ this.props.activeBaseplate === 0 ? 'Blue' : this.props.activeBaseplate === 1 ? 'Black' : this.props.activeBaseplate === 2 ? 'Grey' : 'Beige'}
                    quantity={1} 
                    title={stringData.string_51} 
                    imgSrc={ this.props.activeBaseplate === 0 ? baseplateBlue : this.props.activeBaseplate === 1 ? baseplateBlack : this.props.activeBaseplate === 2 ? baseplateGrey : baseplateBeige} 
                    price={this._addZeroes(baseplatePrice)} 
                    type={'baseplate'}
                  />
                }
              </>
            }
            
            {this._renderAddedProducts(this.props.addedProducts)}
          </div>

          <div className="done">
            <h3>{stringData.string_50}</h3>
            <p>{stringData.string_47}</p>
           
           
            <a target="_blank" className="btn" href={ctaLink}>{stringData.string_55}</a>

            {/* <p>{stringData.string_48}</p> */}
            {/* <p>{stringData.string_49}</p> */}
            {/* <p>
              {
                activeLanguage === 'german' ? 
                <>Hier kannst du Taschen in deiner eigenen Farbkombination erstellen, oder aus unseren <a target="_blank" href="https://vantale.de/pages/components-overview">Standardfarben</a> wählen.</> :
                <>In the next step you can design your Modules with the POCKET MODIFIER or choose one of our <a target="_blank" href="https://vantale-store.de/pages/components-overview">standard colors</a>.</>
              }
            </p> */}
          </div>

          {/* <div className="buttons">
            <button className="btn btn-reset" onClick={() => this.props.clearRenderedProducts()}>Reset</button>
            
            {!this.props.isWallBaseplate ?
              <button disabled={this.props.checkoutLoading} className={`btn btn-checkout ${this.props.checkoutLoading ? 'loading': null }`} onClick={() => this.props.checkout()}>
                <img src={Loading} alt="Loading" />
                <span>Check Out</span>
              </button>
              : 
              <button disabled={this.props.checkoutLoading} className={`btn btn-checkout`} onClick={() => this.props.beforeCheckout()}>
                <span>Check Out</span>
              </button> 
            }
          </div> */}

          {this.props.isCreator &&
            <div className="generated-code">
            <textarea readOnly value={'http://customize.vantale.de/?type=preconfigured&activeInitialBaseplate='+ this.props.activeInitialBaseplate +'&activeBaseplate='  + this.props.activeBaseplate +   '&isWallBaseplate=' + this.props.isWallBaseplate + '&activeCord=' + this.props.activeCord + '&query=' + this.props.generatedCode}></textarea>
            <button onClick={() => this.props.generateCode()} >Generate URL</button>
          </div>
          }
        </div>
      </div>
    );
  }
}

export default Sidebar;